import useSWR from 'swr';
import { maternityWear } from '../../Constants/GeneralItemsKeys';
import { getCategoryKey, getPriceType } from '../../Utils/helper';
import { tabByKeyFetcher } from '../../datafetchers/CategoryPage';

export const newCategorDataFetcher = async (
  setShowPrice,
  webUrl,
  showNewUI,
  categoryId,
) => {
  const apiRequiredData = {
    'key': showNewCategoryUI(showNewUI, categoryId)
      ? maternityWear
      : getCategoryKey(webUrl),
    'Mylo-In-App': false,
    // limit: 5,
    // skip: 0,
    'type': getPriceType(),
    'userType': 'A',
  };

  const categoryData = await tabByKeyFetcher(apiRequiredData);

  setShowPrice(true);
  return categoryData;
};
export const useGetCategoriesData = (
  initialData,
  webUrl,
  setShowPrice,
  showNewUI,
  categoryId,
  experimentPage,
) => {
  const options = {
    fallbackData: initialData,
    revalidateOnFocus: false,
    revalidateOnMount: experimentPage ? false : true,
    revalidateOnReconnect: false,
  };
  if (!initialData) {
    delete options.initialData;
  }
  const { data, error, mutate } = useSWR(
    webUrl,
    () => newCategorDataFetcher(setShowPrice, webUrl, showNewUI, categoryId),
    options,
  );
  return {
    categoryData: data,
  };
};

export const getSeoData = (categoryData, webUrl, firstItem) => {
  const metaTitle =
    categoryData?.data?.metaTitle || categoryData?.data?.tabName;
  const metaDescription = categoryData?.data?.metaDescription;
  const openGraphData = {
    title: metaTitle,
    description: metaDescription,
    type: 'ecommerce',
    url:
      webUrl == 'Cloth-Diapers-5180'
        ? 'https://mylofamily.com/category/cloth-diapers-5180'
        : `https://mylofamily.com${webUrl}`,
  };
  if (firstItem) {
    openGraphData['images'] = [
      {
        url: firstItem?.image,
        width: 600,
        height: 600,
        alt: firstItem?.nickname,
      },
    ];
  }
  return { metaTitle, metaDescription, openGraphData };
};

export const showNewCategoryUI = (showNewUI, categoryId) => {
  return showNewUI && categoryId === '5366';
  //return categoryId === "5366";
};

export const getStructuredData = (data, index, categoryId) => {
  return categoryId == 7023
    ? {
        '@type': 'ListItem',
        'position': index + 1,
        'item': {
          '@type': 'Product',
          'url': `https://mylofamily.com${data?.webUrl || data?.web_url}`,
          'name': data?.name || data?.nickname,
          'image': data?.image,
          'aggregateRating': {
            '@type': 'AggregateRating',
            'ratingValue':
              data?.avg_rating != '0' && data?.avg_rating != 0
                ? data?.avg_rating
                : '4',
            'bestRating': '5',
            'ratingCount': data?.starRatingSubScript?.replace(/[()]/g, ''),
          },
        },
      }
    : {
        '@type': 'ListItem',
        'position': index + 1,
        'name': data?.name || data?.nickname,
        'image': data?.image,
        'url': `https://mylofamily.com${data?.webUrl || data?.web_url}`,
      };
};

export const showNewReviewSection = (userType) => {
  return true;
};
